import React from "react";

const Chapter3 = () => {
  return (
    <>
      <h2>How do metals and other trace elements get into the river?</h2>
      <p>
        Trace elements find their way into our waterways from natural and human
        sources. Naturally, rock and soil erode and elements dissolve into our
        rivers and streams. Mining, industrial and municipal runoff, atmospheric
        deposition, and nuclear reactions also contribute to increasing trace
        elements amounts in waterways. Most trace elements remain in sediment,
        but some can partially dissolve into water as well.
      </p>
      <img
        style={{ width: "88%", margin: "20px auto" }}
        alt="metals 2"
        src="/static/img/storylines/metals2.png"
      />
      <h2>Selenium as a specific example:</h2>
      <p>
        Selenium is found in sedimentary rocks, coal, shale, and soil.
        Irrigation water can release selenium from sediment and rocks into
        groundwater aquifers. Selenium found in the Denver Basin aquifer can be
        attributed to this process. The arid climate of the front range and
        presence of selenium in sediment creates high risk for increased
        selenium levels. The selenium in groundwater aquifers can affect nearby
        streams and rivers. Irrigation of soils containing selenium can dissolve
        and mobilize it so that it is transported in water and concentrated.
      </p>
    </>
  );
};

export default Chapter3;
